var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5355_3342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62396 2.72377L5.86284 0.962647C5.71752 0.817334 5.57013 0.743652 5.42477 0.743652C5.22518 0.743652 4.99213 0.895453 4.99213 1.32329V1.92285C3.71262 1.97862 2.51774 2.50336 1.60639 3.41467C0.64112 4.37987 0.109466 5.66319 0.109375 7.02825C0.109375 7.12632 0.172101 7.21342 0.265127 7.24446C0.288877 7.25238 0.31319 7.25619 0.337274 7.25619C0.407583 7.25619 0.475643 7.22357 0.519527 7.16516C1.59564 5.73276 3.21577 4.88624 4.99213 4.81941V5.40975C4.99213 5.83756 5.22518 5.98939 5.42476 5.98939H5.4248C5.57015 5.98939 5.71754 5.91571 5.86284 5.77041L7.62394 4.00926C7.79512 3.83814 7.88938 3.60988 7.88938 3.36651C7.88938 3.12319 7.79512 2.89491 7.62396 2.72377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5355_3342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.78,
    height: 7.78,
    fill: "white",
    transform: "translate(0.109375 0.109985)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f832100847d8b9913a6b1678a189c2c1.svg";
export { ForwardRef as ReactComponent };